import router from '@/router/index';
import authApi from '@/services/api/authentication';
import tokenService from '../../services/tokenService';
import dayjs from 'dayjs';

export default {
    namespaced: true,
    state: {
        eventsList: ['input', 'click', 'wheel', 'ontouchstart', 'touchmove'],
        lastAction: {
            timeToLogout: 0,
            interval: null,
            intervalTimeout: 1000,
            modal: false
        },
        regeneration: {
            interval: null,
            intervalTimeout: 10000
        },
        forcedToLogout: false,
        isRefreshRequestSent: false
    },
    getters: {
        logoutModal: (state) => state.lastAction.modal,
        timeToLogout (state) {
            return dayjs().startOf('hour').second(state.lastAction.timeToLogout).format('mm:ss');
        },
        isForcedToLogout: (state) => state.forcedToLogout,
        isRefreshRequestSent: (state) => state.isRefreshRequestSent
    },
    mutations: {
        activeUserAction (state) {
            state.lastAction.modal = false;
        },
        syncModalInTabs (state, data) {
            if (state.lastAction.modal === false) {
                state.lastAction.modal = data.modal;
            }
        },
        stop (state) {
            clearInterval(state.lastAction.interval);
            state.lastAction.interval = null;
            clearInterval(state.regeneration.interval);
            state.regeneration.interval = null;
        },
        setForcedToLogout (state, payload) {
            state.forcedToLogout = payload;
        },
        setIsRefreshRequestSent (state, payload) {
            state.isRefreshRequestSent = payload;
        }
    },
    actions: {
        initTokenRegeneration (context) {
            tokenService.setLastActivityTimestamp(dayjs().unix());
            context.dispatch('setListeners');
            context.dispatch('setIntervals');
        },
        setListeners (context) {
            context.state.eventsList.forEach((event) => {
                window.addEventListener(event, () => {
                    tokenService.setLastActivityTimestamp(dayjs().unix());
                    context.commit('activeUserAction');
                });
            });
        },
        setIntervals (context) {
            if (context.state.lastAction.interval === null) {
                context.state.lastAction.interval = setInterval(() => {
                    context.dispatch('lastActionInterval');
                }, context.state.lastAction.intervalTimeout);
            }

            if (context.state.regeneration.interval === null) {
                context.state.regeneration.interval = setInterval(() => {
                    context.dispatch('refreshToken');
                }, context.state.regeneration.intervalTimeout);
            }
        },
        lastActionInterval ({ dispatch, commit, state }) {
            if (state.forcedToLogout === true) {
                dispatch('logout', null, { root: true }).then(() => {
                    state.lastAction.modal = false;
                    router.push({ name: 'login', params: { logoutReason: true } });
                });
            }
            if (tokenService.isInactivityTimeoutExceeded() === true) {
                dispatch('logout', null, { root: true }).then(() => {
                    state.lastAction.modal = false;
                    commit('setForcedToLogout', true);
                    router.push({ name: 'login', params: { logoutReason: true } });
                });
            }
            if (tokenService.shouldShowInactivityModal() === true) {
                state.lastAction.timeToLogout = tokenService.getTimeToLogout();
                state.lastAction.modal = true;
                commit('syncModalInTabs', { modal: state.lastAction.modal });
            }
        },
        refreshToken (context) {
            if (context.state.isRefreshRequestSent === true) {
                context.commit('setIsRefreshRequestSent', true);
            }
            /*
       * do nothing, there is no valid token to refresh
       */
            if (tokenService.isTokenValid() === false) {
                return;
            }

            /*
       * do nothing, user is inactive for more than specified timeout
       */
            if (tokenService.isInactivityTimeoutExceeded() === true) {
                return;
            }

            /*
       * do nothing, token has more time to live than refresh trigger
       */
            if (tokenService.shouldRefreshToken() === false) {
                return;
            }

            if (context.getters.isRefreshRequestSent === false) {
                context.commit('setIsRefreshRequestSent', true);
                authApi.refreshToken().then(() => {
                    context.commit('setIsRefreshRequestSent', false);
                });
            }
        }
    }
};
